import I18n from '../../services/I18n'


class EmbeddedPostsConsent {
    neededConsentLevel = ['C0001', 'C0002', 'C0003', 'C0004']
    isFirstEvaluation = true
    loadedScripts = []

    constructor(el) {

        this.embeddedposts = el

        this.embeddedposts.map((embeddedpost) => {

            //widgets comes in different flavors:
            //Iframe, inlne script, normal script, to load them there are different mechanism needed
            //register event, to init  them later

            //for iframe and inline-Script (lazy loading via data-src)
            const iframeOrScript = embeddedpost.querySelector('[data-src]')
            const widgetScript = embeddedpost.querySelector('[data-script]')
            if (iframeOrScript) {
                embeddedpost.addEventListener('initElement', (e) => {
                    iframeOrScript.src = iframeOrScript.dataset.src
                }, false)
            } else if (widgetScript) {
                //widget script ->  append to body
                embeddedpost.addEventListener('initElement', (e) => {

                    if (!this.loadedScripts.includes(widgetScript.dataset.script)) {
                        this.loadedScripts.push(widgetScript.dataset.script)
                        const wScript = document.createElement("script");
                        wScript.setAttribute("src", widgetScript.dataset.script);
                        document.body.appendChild(wScript);
                    }

                }, false)
            }

            //EmbeddedConcentElement (youtube, vimeo) already have the initElement event

            //event to add and remove the consent frame
            embeddedpost.addEventListener('removeConsentFrame', (e) => {
                const consentframe = embeddedpost.querySelector('.consentframe')
                if (consentframe) {
                    consentframe.remove()
                }
            }, false)

            embeddedpost.addEventListener('appendConsentframe', (e) => {
                const consentframe = embeddedpost.querySelector('.consentframe')
                if (!consentframe) {
                    embeddedpost.appendChild(this.generateCookieConsentFrame())
                }
            }, false)
        })


    }

    concentEvaluation() {

      


        if (this.isNeededConsentLevelReached()) {
            //granted

          

            this.embeddedposts.map((embeddedpost) => {
                embeddedpost.dispatchEvent(new Event("removeConsentFrame"))
                embeddedpost.dispatchEvent(new Event("initElement"))
            })
        } else if (this.isFirstEvaluation) {
            this.embeddedposts.map((embeddedpost) => {
                embeddedpost.dispatchEvent(new Event("appendConsentframe"))
            })
        }
        this.isFirstEvaluation = false

    }

    isNeededConsentLevelReached() {

        if (typeof OneTrust == 'undefined') {
            //OneTrust is not init
            return false
        }

        /*
        if (OneTrust.IsAlertBoxClosedAndValid() === false) {
            //Alert Box not Closed and Valid
            return false
        }
            */

        const currentConsentLevel = OnetrustActiveGroups.split(',').filter(e => e.length)
        
        const allLevelAreIncluded = this.neededConsentLevel.every(e => currentConsentLevel.includes(e))

      

        return allLevelAreIncluded
    }


    generateCookieConsentFrame() {
        const consentMarkup = document.createElement("div")
        const i18n = new I18n()
        consentMarkup.classList = 'consentframe'
        consentMarkup.innerHTML = `
         <div class="consentframe__body">
            <h2 class="h4">${ i18n.t('embeddedPostsTitle') }</h2>
            <p>${ i18n.t('embeddedPostsBody') }</p>
            <p>
                <button class="consentframe__button action action-primary action--center">${ i18n.t('embeddedPostsButton') }</button>
            </p>
            <p class="text-align-right">
                <button 
                onclick="window.OneTrust.ToggleInfoDisplay()"
                class="link">${ i18n.t('embeddedPostsMoreInfos') }
                </button>
            </p>
          </div>
          `;

        const giveConcentButton = consentMarkup.querySelector('.consentframe__button')
        giveConcentButton.addEventListener('click', () => {
          
          
            OneTrust.AllowAll()
            this.concentEvaluation()
        }, false)


        return consentMarkup;
    }


}

export default EmbeddedPostsConsent
